import { Loader2 } from 'lucide-react';
import { Badge } from '../ui/badge';

// ── Status badge config ───────────────────────────────────────────

const STATUS_CONFIG: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline'; className?: string }> = {
  pending: { label: 'Pending', variant: 'secondary', className: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20' },
  fetching: { label: 'Fetching', variant: 'secondary', className: 'bg-blue-500/10 text-blue-500 border-blue-500/20' },
  ready: { label: 'Ready', variant: 'default', className: 'bg-green-500/10 text-green-500 border-green-500/20' },
  error: { label: 'Error', variant: 'destructive' },
  stale: { label: 'Stale', variant: 'secondary', className: 'bg-orange-500/10 text-orange-500 border-orange-500/20' },
};

export function StatusBadge({ status }: { status: string }) {
  const config = STATUS_CONFIG[status] || { label: status, variant: 'outline' as const };
  return (
    <Badge variant={config.variant} className={config.className}>
      {status === 'fetching' && <Loader2 className="h-3 w-3 mr-1 animate-spin" />}
      {config.label}
    </Badge>
  );
}
